import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { GrIcon } from "../icons";
import { palette } from "../../theme/palette";
import styled from "@emotion/styled";
import classNames from "classnames";
const defaultSize = 18;
const calculatePadding = (size) => {
    const defaultPadding = 7;
    return defaultPadding * ((size || defaultSize) / defaultSize);
};
const StyledIconButton = styled("div")(({ size, color, disabled, style, isActive, isVisualIcon, }) => {
    return {
        backgroundColor: isActive ? palette.blue015 : "inherit",
        padding: calculatePadding(size),
        borderRadius: size,
        width: size,
        height: size,
        transition: "background-color 0.25s",
        cursor: disabled ? "not-allowed" : "pointer",
        boxSizing: "content-box",
        svg: {
            path: {
                fill: isVisualIcon
                    ? undefined
                    : (disabled && palette.grey025) || (color && palette[color]) || (isActive && palette.blue060) || palette.grey050,
            },
        },
        "&:hover": {
            backgroundColor: (disabled && "initial") || palette.grey020,
            svg: {
                path: {
                    fill: isVisualIcon ? undefined : (disabled && palette.grey025) || palette.grey070,
                },
            },
        },
        "&:active": {
            backgroundColor: disabled ? "initial" : palette.grey025,
            svg: {
                path: {
                    fill: isVisualIcon ? undefined : palette.grey070,
                },
            },
        },
        ...style,
    };
});
export function GrIconButton(props) {
    const { iconType, size = defaultSize, disabled, href, className, onClick, isActive, ...others } = props;
    const isVisualIcon = iconType.includes("visual");
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return (_jsx(StyledIconButton, { role: "button", className: classNames("GrIconButton", className), size: size, disabled: disabled, ...others, href: href, onClick: handleClick, isActive: isActive, isVisualIcon: isVisualIcon, children: _jsx(GrIcon, { type: iconType, size: size }) }));
}
//# sourceMappingURL=GrIconButton.js.map